import { css } from '@emotion/react';

// import styled from '@emotion/styled';

export const typography = css`
  :root {
    --font-family-saans: 'saans';
    --font-variant-alternatives: styleset(ss03, ss04);

    --font-weight-normal: 400;
    --font-weight-medium: 500;
    --font-weight-semi-bold: 670;

    --line-height-normal: 1.15em;
    --line-height-large: 1.35em;

    --letter-spacing-small: -0.02em;
    --letter-spacing-medium: 0em;
    --letter-spacing-large: 0.02em;

    // Mobile
    --font-size-xxx-large: 3rem;
    --font-size-xx-large: 2.5rem;
    --font-size-x-large: 2.25rem;
    --font-size-large: 2rem;
    --font-size-medium: 1.5rem;
    --font-size-small: 1.25rem;
    --font-size-x-small: 1rem; //16px
    --font-size-xx-small: 0.875rem; // 14px
    --font-size-xxx-small: 0.75rem; // 12px
    --font-size-tiny: 0.875rem;

    // Tablet
    @media (min-width: 640px) and (max-width: 1120px) {
      --font-size-xxx-large: 4.75rem;
      --font-size-xx-large: 4rem;
      --font-size-x-large: 3.5rem;
      --font-size-large: 2.5rem;
      --font-size-medium: 2rem;
      --font-size-small: 1.5rem;
      --font-size-x-small: 1.25rem;
      --font-size-xx-small: 1rem;
      --font-size-xxx-small: 0.875rem; // 14px
    }

    // Desktop
    @media (min-width: 1121px) {
      --font-size-xxx-large: 5.75rem;
      --font-size-xx-large: 4.75rem;
      --font-size-x-large: 4rem;
      --font-size-large: 3rem;
      --font-size-medium: 2rem;
      --font-size-small: 1.75rem;
      --font-size-x-small: 1.25rem;
      --font-size-xx-small: 1.125rem;
      --font-size-xxx-small: 1rem; // 16px
    }
  }
`;

// Elements
export const displayLarge = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-small);
  font-size: var(--font-size-xxx-large);
`;

export const displayMedium = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-small);
  font-size: var(--font-size-xx-large);
`;

export const headlineLarge = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-small);
  font-size: var(--font-size-x-large);
`;

export const headlineMedium = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-medium);
  font-size: var(--font-size-large);
`;

export const headlineSmall = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-medium);
  font-size: var(--font-size-medium);
`;

export const subheadline = css`
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-small);
`;

export const subheadlineBold = css`
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--line-height-normal);
  letter-spacing: var(--letter-spacing-medium);
  font-size: var(--font-size-small);
`;

// BODY

export const bodyMedium = css`
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-x-small);
`;

export const bodySmall = css`
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-xx-small);
`;

export const bodyMediumSemiBold = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-x-small);
`;

export const bodySmallSemiBold = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-x-small);
`;

export const bodyMediumBold = css`
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-x-small);
`;

export const bodySmallBold = css`
  font-weight: var(--font-weight-semi-bold);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-xx-small);
`;

export const captionLarge = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-x-small);
  text-transform: uppercase;
`;

export const captionSmall = css`
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-large);
  letter-spacing: var(--letter-spacing-large);
  font-size: var(--font-size-xxx-small);
  text-transform: uppercase;
`;

export const fontSizes = [
  'display-lg',
  'display-md',
  'headline-lg',
  'headline-md',
  'headline-sm',
  'subheadline',
  'subheadline-bold',
  'caption-lg',
  'caption-sm',
  'body-md',
  'body-sm',
  'body-md-semi-bold',
  'body-sm-semi-bold',
  'body-md-bold',
  'body-sm-bold',
] as const;
